var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 246,
    height: 293,
    viewBox: "0 0 246 293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19634",
    "data-name": "Rectangle 19634",
    width: 246,
    height: 293,
    transform: "translate(0.038 -0.389)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Seed",
    transform: "translate(-0.038 0.389)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3336",
    "data-name": "Path 3336",
    d: "M.059,326.458Q.059,164.583,0,2.721C0,.5.5,0,2.721,0Q123.035.106,243.362,0c2.212,0,2.721.5,2.721,2.721q-.089,160.543,0,321.087c0,2.212-.5,2.721-2.721,2.721q-121.645-.106-243.3-.059Z",
    transform: "translate(0.002 0.006)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_49822",
    "data-name": "Group 49822",
    transform: "translate(31.975 27.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3337",
    "data-name": "Path 3337",
    d: "M115.155,249.322H31.5c-6.519,0-8.589-2.851-6.542-8.979,3.017-9.05,6.01-18.112,9.062-27.151a15.56,15.56,0,0,0,.816-5.205q-.035-71.532,0-143.076a16.183,16.183,0,0,0-.816-5.205q-4.632-13.7-9.169-27.435c-1.9-5.714.26-8.731,6.329-8.731H199.375c6.081,0,8.163,2.934,6.246,8.743-2.9,8.79-5.773,17.592-8.731,26.358a21.251,21.251,0,0,0-1.148,6.933q.053,69.616,0,139.243a23.165,23.165,0,0,0,1.017,6.968c3.029,9.677,6,19.378,8.979,29.067,1.727,5.619-.4,8.482-6.353,8.482H115.143Z",
    transform: "translate(-24.183 -23.54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3338",
    "data-name": "Path 3338",
    d: "M113.33,32.627c25.128,0,50.255.035,75.371-.047,2.544,0,3.017.544,2.011,2.875-6.459,15-8.127,30.617-7.879,46.943.615,40.59.213,81.192.177,121.793a26.989,26.989,0,0,0,1.242,8.411c2.3,7.122,4.377,14.315,6.755,21.4.8,2.4.331,2.875-2.129,2.875q-72.561-.089-145.134-.047c-2.165,0-4.342-.095-6.507.024-1.952.118-2.354-.379-1.68-2.307,2.449-6.956,4.7-13.972,7.075-20.951a17.807,17.807,0,0,0,.946-5.785q-.035-73.023,0-146.034a17.485,17.485,0,0,0-.935-5.785c-2.354-6.885-4.555-13.806-6.992-20.668-.8-2.271-.379-2.756,2.011-2.745C62.885,32.663,88.107,32.627,113.33,32.627Z",
    transform: "translate(-22.157 -21.885)",
    fill: "#f1f8ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3339",
    "data-name": "Path 3339",
    d: "M87.873,141.758c-12.67-5.288-18.42-13.912-18.42-27.659,0-2.851-.071-5.714.047-8.565.118-3.206,1.94-5.087,5.075-5.489,9.9-1.278,18.254.225,26.488,4.779,1.325-4,.923-5.063-2.6-6.578C88.583,94,82.029,81.47,87.684,70.149A100.5,100.5,0,0,1,103,48.18a5.135,5.135,0,0,1,8.045.012c6.01,6.8,11.44,14.007,15.415,22.265,5.17,10.754-.639,23.081-10.423,27.576-4.117,1.893-4.105,1.917-3.466,7.027a49.251,49.251,0,0,1,6.838-3.431c6.7-2.354,13.629-1.715,20.49-1.443a4.739,4.739,0,0,1,4.626,4.921c.177,4.815.521,9.677-.177,14.457-1.609,10.919-7.914,18.148-18.053,22.194-3.478,1.786-7.217,2.07-11.026,2.035-1.964-.024-3.076.651-1.739,2.756,2.413-.923,4.543-2.484,7.11-2.969a17.634,17.634,0,0,1,5.726-.556c4.034,0,8.068,0,12.114.035,3.975.047,6.093,2.047,6.116,5.962.024,4.531.414,9.074-.237,13.569a26.881,26.881,0,0,1-26.855,23.471q-5.194.059-5.194,5.335c0,6.4-.059,12.8.035,19.2.024,1.775-.414,2.484-2.3,2.331a33.925,33.925,0,0,0-5.9,0c-2.2.213-2.579-.757-2.555-2.709.106-7.086-.059-14.185.095-21.271.047-2.319-.556-3.052-2.922-2.922-8.269.45-15.557-1.976-21.472-7.95A25.388,25.388,0,0,1,69.56,160.7c-.154-4.034-.142-8.08-.035-12.114.095-3.49,2.106-5.454,5.608-5.525,4.034-.083,8.068-.035,12.114-.047,2.378-.639,2.283.059,3.419,0a26.919,26.919,0,0,1,9.618,3.644,1.906,1.906,0,0,0-.024-2.437c-2.011-.994-4.2-.154-6.258-.592-.3-.047-.592-.106-.9-.154a50.536,50.536,0,0,1-5.205-1.715Z",
    transform: "translate(-15.901 -19.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3340",
    "data-name": "Path 3340",
    d: "M106.68,132.909c-2.508-.213-.71-2.023-1.053-3.029-.379-1.112.284-1.846,1.585-1.763a50.236,50.236,0,0,0,12.481-1.148c.13.414-1.372.923.071,1.278-1.976.39-3.951.793-5.939,1.183-1.715-.3-3.4.225-5.111.225-2.2.012-1.633,1.987-2.047,3.253Z",
    transform: "translate(-9.332 -4.609)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3341",
    "data-name": "Path 3341",
    d: "M85.122,126.98a17.809,17.809,0,0,1,5.371,1.159c-.615.958-1.644.308-2.425.627a5.853,5.853,0,0,1-3.608-.521c.556-.13,1.1-.272,1.656-.4-.331-.284-.662-.568-1.006-.852Z",
    transform: "translate(-13.151 -4.607)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3342",
    "data-name": "Path 3342",
    d: "M104.434,59.7a99.577,99.577,0,0,1,7.891,12.41,9.43,9.43,0,0,1-1.183,10.979,10.136,10.136,0,0,1-11.109,3.549c-4.259-1.148-6.8-4.105-7.749-8.411-.5-2.26.284-4.259,1.207-6.235,2.26-4.839,5.548-9.015,8.612-13.333,1.372-.97,1.633.532,2.342,1.053Z",
    transform: "translate(-11.747 -17.17)",
    fill: "#f1f8ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3343",
    "data-name": "Path 3343",
    d: "M127.245,104.729c-.024,11.653-8.329,18.858-19.946,17.6-1.3-.142-1.562-.639-1.656-1.822-.982-12.516,7.169-20.68,19.733-19.78,3.454.248,1.112,2.875,1.869,3.987Z",
    transform: "translate(-9.288 -9.424)",
    fill: "#f1f8ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3344",
    "data-name": "Path 3344",
    d: "M127.24,141.449c-.035,11.322-8.778,18.8-20.064,17.225-1.372-.189-1.455-.864-1.526-1.952-.935-13.522,8.447-20.384,18.692-19.674,2.224.154,3.336.532,2.922,2.922a8.668,8.668,0,0,0-.012,1.467Z",
    transform: "translate(-9.284 -2.774)",
    fill: "#f1f8ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3345",
    "data-name": "Path 3345",
    d: "M99.94,117.827q0,4.566-4.768,4.507a16.9,16.9,0,0,1-16.681-20.147,1.465,1.465,0,0,1,1.467-1.42c10.979-1.739,19.958,5.915,19.97,17.059Z",
    transform: "translate(-14.293 -9.45)",
    fill: "#f1f8ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3346",
    "data-name": "Path 3346",
    d: "M99.942,154.191q0,4.507-4.519,4.472c-11.073-.083-18.834-9.37-16.917-20.183.177-.994.592-1.23,1.514-1.361,11.215-1.514,19.922,5.915,19.934,17.071Z",
    transform: "translate(-14.294 -2.787)",
    fill: "#f1f8ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3347",
    "data-name": "Path 3347",
    d: "M87.52,128.581c.663-.769,1.692-.13,2.425-.627a.722.722,0,0,1,.521.047c2.532.852,5.194-.166,7.725.58v4.8A31.366,31.366,0,0,0,87.52,128.581Z",
    transform: "translate(-12.59 -4.434)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3348",
    "data-name": "Path 3348",
    d: "M106.573,132.653c-1.242-3.7-.946-4.223,2.7-4.129,1.491.035,3.135-.663,4.46.651C111.34,130.334,108.962,131.493,106.573,132.653Z",
    transform: "translate(-9.225 -4.353)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3349",
    "data-name": "Path 3349",
    d: "M97.735,128.6c-2.567-.367-5.217.5-7.725-.58C92.589,128.128,95.251,127.2,97.735,128.6Z",
    transform: "translate(-12.135 -4.453)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3350",
    "data-name": "Path 3350",
    d: "M102.892,59.784c-.84-.213-1.124-1.668-2.342-1.053C101.757,57.429,101.958,57.524,102.892,59.784Z",
    transform: "translate(-10.206 -17.253)",
    fill: "#4b4b4b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeed);
export default __webpack_public_path__ + "static/media/Seed.04dc0bb326b69b028680a1ffce126f11.svg";
export { ForwardRef as ReactComponent };